const messages = {
  title: "Tienda de regalos",
  description: "Bienvenido a la tienda premium. Aquí puedes canjear tus puntos Bridgestone Plus por recompensas de varias categorías. La gama de productos se actualiza periódicamente.",
  sort: {
    asc: "Ordenar por: Precio más bajo",
    desc: "Ordenar por: Precio más alto",
  },
  productSearchBox: {
    from: "puntos desde",
    to: "puntos hasta",
  },
  noProducts: "Los criterios de búsqueda no arrojaron ningún resultado",
  quantity: "Cantidad",
  search: "Buscar",
  perPage: "Artículos por página",
  timeUnavailable: "Actualmente no disponible en este momento",
  product: "Producto",
  cart: {
    pointsPerUnit: "Puntos por unidad",
    pointsSum: "Suma de puntos",
  },
  action: "Acción",
  pointsTotal: "Total",
  cartRemainPoints: "Puntos restantes",
  shoppingCart: "Carro de la compra",
  emptyCart: "El carrito de compras está vacío.",
  attributes: "Atributos",
  selectAddressP: "Por favor, selecciona tu dirección de entrega",
  orderDelivery: "Dirección de envío",
  selectedProducts: "Productos seleccionados",
  orderSummary: "Descripción general del pedido",
  contactPerson: "Persona de contacto",
  selectedAddress: "Dirección seleccionada",
  order: {
    success: "¡Gracias! Tu pedido se realizó correctamente. Recibirás la confirmación en tu bandeja de entrada en unos minutos.",
    description: "Encuentra aquí toda la información relativa a tus pedidos realizados en tienda de recompensas.",
    info: "Aquí puedes encontrar un resumen de tus pedidos de la tienda.",
    date: "Fecha de pedido",
    number: "Número de pedido",
    status: {
      created: "Pagado",
      confirm_order: "Confirmar pedido",
      ready_for_shipment: "Listo para envío",
      rejected: "Rechazado",
      processed: "Procesado",
      shipped: "Enviado",
      returned: "Devuelto",
      finished: "Finalizado",
    },
    anyOrder: "No hay pedidos",
    products: "Productos",
    quantity_short: "pcs",
    itemRemoved: "no se puede entregar",
  },
  orders: "Mis pedidos",
  notEnoughPoints: "No hay suficientes puntos disponibles.",
  statusText: "Estado",
  outOfStock: "Actualmente no disponible en stock",
  productUnavailable: "Este producto ya no está disponible.",
  deletedProductsTitle: "Productos no disponibles",
  deletedProductsMessage: "Los siguientes productos ya no están disponibles. Elimínelos del carrito para continuar.",
  removeSelected: "Eliminar selección",
  clearCart: "Vaciar carrito",
  removeSelectedConfirm: "¿Eliminar los productos seleccionados del carrito?",
  clearCartConfirm: "¿Eliminar todos los productos del carrito?",
  incompleteAddress: {
    firstName: "Añada un nombre a la dirección de entrega",
    lastName: "Añada un apellido a la dirección de entrega",
    company: "Añada un nombre de empresa a la dirección de entrega",
    street: "Añada una calle y número a la dirección de entrega",
    postalCode: "Añada un código postal a la dirección de entrega",
    city: "Añada una ciudad a la dirección de entrega",
    country: "Añada un país a la dirección de entrega",
    phone: "Añada un número de teléfono a la dirección de entrega",
  },
  placeOrder: "Pedido vinculante",
  toOrderDelivery: "Continuar a la dirección de entrega",
  toOrderSummary: "Ir al resumen del pedido",
  productImg: "Imagen del producto",
  selectAddressBtn: "Elegir dirección",
  perPgae: "Artículos por página",
  categories: {
    advertising: {
      title: "Material publicitario",
      desc: "Participe directamente aquí en la plataforma y consiga <br/> 40 puntos extra para el club de recompensas.",
    },
    rewards: {
      title: "Recompensas exclusivas",
      desc: "Descubra la oferta de bonificación en nuestro centro de formación o en su ubicación.",
    },
    tools: {
      title: "Herramientas de taller",
      desc: "Utilice sus puntos para formaciones de terceros <br/> y reduzca sus costes.",
    },
    trainings: {
      title: "Formación y cursos",
      desc: "Descubra la oferta de bonificación en nuestro centro de formación o en su ubicación.",
    },
    salesroom: {
      title: "Sala de ventas",
      desc: "Prepare la sala de ventas y ofrezca a sus clientes una estancia agradable.",
    },
    hunter: {
      title: "Hunter",
      desc: "Canjee puntos por atractivo equipamiento de taller de Hunter.",
    },
  },
  bestSold: "Más vendidos",
  seasonal: "De temporada",
  affordable: "Casi listo",
  forPoints: "por {points} puntos",
  reachedPoints: "Puntos requeridos alcanzados",
  remainingPoints: "Faltan {points} puntos",
  favoriteProducts: {
    description: "Aquí encontrará los productos que ha guardado.",
  },
  categoryPageDescriptionFallback: "Material para el taller u otros productos de calidad con el logotipo de Bridgestone para su empresa",
  variant: "Variantes seleccionables",
};
export default {
  messages,
};
